import React, { useContext } from "react";
import { Navigate } from 'react-router-dom'
import { SiSpinrilla } from "react-icons/si";

import { AuthContext } from "../services/Session";
import MiddleLayout from "../layouts/MiddleLayout";

import Logo from '../assets/logo.png'

const PrivateRoute = ({ component } : any) => {
  const { user, error, loading } = useContext(AuthContext)

  if(loading) {
    return <MiddleLayout>
      <div className="justify-center flex flex-col items-center">
        <img src={Logo} alt='logo app' className="h-48"/>
        <SiSpinrilla size={64} className="mr-2 animate-spin text-purple-600 text-center"/>
      </div>
    </MiddleLayout>
  }

  if(error) {
    return <MiddleLayout>
      <div className="justify-center flex flex-col items-center">
        <img src={Logo} alt='logo app' className="h-48"/>
        <span className="text-slate-800">Oups ! Une erreur est survenue. Veuillez réessayer ultérieurement...</span>
      </div>
    </MiddleLayout>
  }

  if(user) {
    return component
  }

  return <Navigate to="/login" />
}

export default PrivateRoute
